module.exports = __webpack_public_path__ + "img/3.826d75e9.svg";